import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import siterverseLogo from '../images/siteverse_logo.svg';
import '../App.css';
import styles from '../pages/Home/Home.module.css';
import callicon from '../images/call.svg';

function Header() {
    const [menuVisible, setMenuVisible] = useState(false);

    const toggleMenu = () => {
        setMenuVisible(!menuVisible);
    };

    const closeMenu = () => {
        setMenuVisible(false);
    };

    return (
        <header>
            <nav>
                <div className={`${styles.w1080} ${styles.navbr} d-flex justify-space-between align-center`}>
                    <div className={styles.logoContainer}>
                        <img src={siterverseLogo} alt='siteverselogo' />
                    </div>
                    {/* Navigation links */}
                    <div className={`${styles.navLinks} ${menuVisible ? styles.visible : ''}  justify-space-between gap-40`}>
                        <Link to='/' className={styles.navmenus} onClick={closeMenu}>Home</Link>
                        <a href='#solutions' className={styles.navmenus} onClick={closeMenu}>Solutions</a>
                        <a href='#process' className={styles.navmenus} onClick={closeMenu}>Process</a>
                    </div>
                    <div className={styles.ctaContainer}>
                        <button className={styles.primarybtn}><img src={callicon} alt="call icon"/>Book a call</button>
                    </div>
                    {/* Hamburger menu for mobile - moved to right */}
                    <div
                        className={styles.navmenu}
                        onClick={toggleMenu}
                        aria-label="Open navigation"
                        tabIndex={0}
                        role="button"
                        onKeyDown={e => (e.key === 'Enter' || e.key === ' ') && toggleMenu()}
                    >
                        <span className={styles.hamburger}>
                            <span />
                            <span />
                            <span />
                        </span>
                    </div>
                </div>
            </nav>
        </header>
    );
}

export default Header;